module.exports = __webpack_public_path__ + "img/JE.fb6c4d5c.png";